import React from 'react';
import { motion } from 'framer-motion';
import { ChevronLeftIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
type PageHeaderProps = {
  title: string;
  subtitle?: string;
  showBack?: boolean;
  urgent?: boolean;
};
export function PageHeader({
  title,
  subtitle,
  showBack = true,
  urgent = false
}: PageHeaderProps) {
  const navigate = useNavigate();
  return <header className="sticky top-0 z-40 bg-[#0a0a0a]/95 backdrop-blur-lg border-b border-[#2a2a2a]" data-id="element-48">
      <div className="px-4 py-3 pt-[env(safe-area-inset-top)]" data-id="element-49">
        <div className="flex items-center gap-3" data-id="element-50">
          {showBack && <motion.button onClick={() => navigate(-1)} className="flex items-center justify-center w-10 h-10 -ml-2 rounded-full active:bg-[#252525]" whileTap={{
          scale: 0.95
        }} aria-label="Go back" data-id="element-51">
              <ChevronLeftIcon className="w-6 h-6 text-[#d4a853]" data-id="element-52" />
            </motion.button>}
          <div className="flex-1 min-w-0" data-id="element-53">
            <h1 className={`text-lg font-bold truncate ${urgent ? 'text-[#dc2626]' : 'text-white'}`} data-id="element-54">
              {title}
            </h1>
            {subtitle && <p className="text-xs text-[#a3a3a3] truncate" data-id="element-55">{subtitle}</p>}
          </div>
        </div>
      </div>
    </header>;
}